import { IconTile } from '@/shared/components/icon-tile';
import type { Category } from './category';
import { CATEGORY_LABELS } from './category-labels';

type CategoryIconProps = {
  readonly category: Category;
};

export function CategoryIcon({ category }: CategoryIconProps) {
  return <IconTile icon={CATEGORY_LABELS[category].icon} />;
}
